import styled from 'styled-components';
import { DefaultButton, DefaultInput } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const SearchBoxCont = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SearchButton = styled(DefaultButton)`
  width: 111px;
  height: 48px;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    border: 2px solid ${theme.colors.primary[100]};
    border-radius: ${theme.layout.spacing.mikro};
    color: ${theme.colors.primary[100]};
  `};

  svg {
    position: relative;
    top: 2px;
    height: 16px;
    margin: 0 10px 0 0;
  }
`;

export const SearchInput = styled(DefaultInput)`
  margin: 0 16px 0 0;
`;

export const SearchInputCont = styled.div`
  position: relative;
`;

export const SearchInputIcon = styled.span`
  position: absolute;
  top: 15px;
  left: 12px;
`;
